import React from 'react';
import Configuration from '../components/Configuration';

const ConfigurationPage: React.FC = () => {
  return <Configuration />;
};

export default ConfigurationPage; 